import { Injectable, Provider, signal } from '@angular/core';
import { Route } from '@angular/router';
import { APPLICATION_CONTEXT, ApplicationContext, NavMenuItem } from '@processpuzzle/base-widget';
import { appRoutes } from '../app.routes';

/**
 * This application's answer to base-widget's `APPLICATION_CONTEXT`: its name, its logo and the
 * titled routes, for `app-title` and `nav-menu` to read without props.
 *
 * base-app's shell provides the context from the `AppDefinition` it renders; this application is
 * hand-built and has no definition, so it provides its own. Only titled routes are navigation,
 * exactly as in the sidenav: the auth matcher route and the `''` redirect carry no title.
 */
@Injectable()
export class AdminApplicationContext implements ApplicationContext {
  readonly name = signal('ProcessPuzzle Admin').asReadonly();
  readonly logoUrl = signal<string | undefined>('assets/processpuzzle-logo-with-title.jpg').asReadonly();
  readonly navItems = signal(appRoutes.filter((route) => route.title !== null && route.title !== undefined).map(toNavMenuItem)).asReadonly();
}

export function provideAdminApplicationContext(): Provider[] {
  return [{ provide: APPLICATION_CONTEXT, useClass: AdminApplicationContext }];
}

function toNavMenuItem(route: Route): NavMenuItem {
  const menuTitle = (route.data?.['menuTitle'] as string) ?? '';
  const icon = route.data?.['icon'] as string | undefined;
  // Absolute, so the link resolves the same from whichever route the menu is opened on.
  const routePath = `/${route.path ?? ''}`;
  return { id: routePath, label: menuTitle, translocoId: `navigation.${menuTitle}`, ...(icon ? { icon } : {}), routePath };
}
